import React from "react";
import SystemError from "./components/SystemError";
import Header from "./components/Header/Header";
import Products from "./components/products/Products";
import SessionCallback from "./components/sessionCallback/SessionCallback";
import WebFont from "webfontloader";

import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";

import './App.css';

import { WalletProvider } from "./contexts/Wallet";


function App() {

React.useEffect(() => {
  WebFont.load({
    google: {
      families: ["Jaldi"]
    }
  })
}, [])


  return (
    <WalletProvider>
      <SystemError/>
        <Header />
          <Router>
              <Routes>
                <Route path="/" element={<Products/>} />
                <Route path="/products" element={<Products/>} />
                <Route path="/session_callback" element={<SessionCallback/>} />
              </Routes>
          </Router>
    </WalletProvider>
  );
}

export default App;
